export const set = (key: string, value: string) => window.localStorage.setItem(key, value);

export const get = (key: string, defaultValue: string | null = null): string | null =>
  window.localStorage.getItem(key) || defaultValue;

export const remove = (key: string): void => {
  window.localStorage.removeItem(key);
};
